var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "disableShortcut",
      attrs: { id: "representative-settings" },
    },
    [
      _c(
        "a-tabs",
        {
          attrs: {
            "default-active-key": "1",
            "tab-position": _vm.mode,
            scrollable: "",
          },
        },
        [
          _c("a-tab-pane", { key: "1" }, [
            _c(
              "span",
              {
                attrs: { slot: "tab", title: _vm.$t("message.profile") },
                slot: "tab",
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.$t("message.profile").length > 20
                        ? _vm.$t("message.profile").substring(0, 20) + "..."
                        : _vm.$t("message.profile")
                    ) +
                    "\n            "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "containerKeyOne" },
              [
                _c(
                  "label",
                  { staticClass: "imgUpload" },
                  [
                    _vm.$_.get(_vm.user, "gravatar") === null &&
                    _vm.gravatar === null
                      ? _c("a-avatar", { attrs: { size: 84, icon: "user" } })
                      : _c("a-avatar", {
                          attrs: {
                            size: 84,
                            src:
                              _vm.gravatar || _vm.$_.get(_vm.user, "gravatar"),
                          },
                        }),
                    _vm._v(" "),
                    _c("input", {
                      staticClass: "d-none",
                      attrs: { id: "profile-avatar", type: "file" },
                      on: { change: _vm.uploadFile },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "imgUploadOver" }, [_vm._v("+")]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", [
                  _c("div", { staticClass: "emailAddress" }, [
                    _vm._v(_vm._s(_vm.$t("message.email"))),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "emailAddress" }, [
                    _vm._v(_vm._s(_vm.$_.get(_vm.user, "email"))),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "md-field",
                  { staticClass: "disableShortcut" },
                  [
                    _c("label", { staticClass: "md-fieldLabel" }, [
                      _vm._v(_vm._s(_vm.$t("message.username"))),
                    ]),
                    _vm._v(" "),
                    _c("md-input", {
                      staticClass: "disableShortcut mDinput",
                      model: {
                        value: _vm.user.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.user, "name", $$v)
                        },
                        expression: "user.name",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.changeUserName },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("message.updateUserName")) +
                        "\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "a-tab-pane",
            { key: "2" },
            [
              _c(
                "span",
                {
                  attrs: {
                    slot: "tab",
                    title: _vm.$t("message.changePassword"),
                  },
                  slot: "tab",
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$t("message.changePassword").length > 17
                          ? _vm.$t("message.changePassword").substring(0, 17) +
                              "..."
                          : _vm.$t("message.changePassword")
                      ) +
                      "\n            "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "md-field",
                {
                  staticClass: "disableShortcut",
                  class: {
                    "md-invalid":
                      _vm.errors.first(_vm.$t("message.oldPassword")) != null,
                  },
                },
                [
                  _c("label", [
                    _vm._v(_vm._s(_vm.$t("message.oldPassword", { num: "6" }))),
                  ]),
                  _vm._v(" "),
                  _c("md-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|min:6",
                        expression: "'required|min:6'",
                      },
                    ],
                    ref: _vm.$t("message.password"),
                    staticClass: "disableShortcut",
                    attrs: {
                      name: _vm.$t("message.oldPassword"),
                      placeholder: _vm.$t("message.oldPassword", { num: "6" }),
                      autocomplete: "off",
                      trim: "",
                      type: "password",
                    },
                    model: {
                      value: _vm.oldPassword,
                      callback: function ($$v) {
                        _vm.oldPassword = $$v
                      },
                      expression: "oldPassword",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "md-error" }, [
                    _vm._v(
                      _vm._s(_vm.errors.first(_vm.$t("message.oldPassword")))
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "md-field",
                {
                  staticClass: "disableShortcut",
                  class: {
                    "md-invalid":
                      _vm.errors.first(_vm.$t("message.newPassword")) != null,
                  },
                },
                [
                  _c("label", [
                    _vm._v(_vm._s(_vm.$t("message.newPassword", { num: "6" }))),
                  ]),
                  _vm._v(" "),
                  _c("md-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|min:6",
                        expression: "'required|min:6'",
                      },
                    ],
                    ref: _vm.$t("message.password"),
                    staticClass: "disableShortcut",
                    attrs: {
                      name: _vm.$t("message.newPassword"),
                      placeholder: _vm.$t("message.passwordAtLeast", {
                        num: "6",
                      }),
                      autocomplete: "off",
                      trim: "",
                      type: "password",
                    },
                    model: {
                      value: _vm.newPassword,
                      callback: function ($$v) {
                        _vm.newPassword = $$v
                      },
                      expression: "newPassword",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "md-error" }, [
                    _vm._v(
                      _vm._s(_vm.errors.first(_vm.$t("message.newPassword")))
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "md-field",
                {
                  staticClass: "disableShortcut",
                  class: {
                    "md-invalid":
                      _vm.errors.first(_vm.$t("message.passwordRepeat")) !=
                      null,
                  },
                },
                [
                  _c("label", [
                    _vm._v(_vm._s(_vm.$t("message.passwordRepeat"))),
                  ]),
                  _vm._v(" "),
                  _c("md-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value:
                          "confirmed:" + _vm.$t("message.password") + "|min:6",
                        expression:
                          "'confirmed:' + $t('message.password') + '|min:6'",
                      },
                    ],
                    staticClass: "disableShortcut",
                    attrs: {
                      name: _vm.$t("message.passwordRepeat"),
                      autocomplete: "off",
                      type: "password",
                    },
                    model: {
                      value: _vm.passwordConfirmation,
                      callback: function ($$v) {
                        _vm.passwordConfirmation = $$v
                      },
                      expression: "passwordConfirmation",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "md-error" }, [
                    _vm._v(
                      _vm._s(_vm.errors.first(_vm.$t("message.passwordRepeat")))
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.changePassword },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("message.changePassword")) +
                      "\n            "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("a-tab-pane", { key: "3" }, [
            _c(
              "span",
              {
                attrs: {
                  slot: "tab",
                  title: _vm.$t("message.soundSettings"),
                  id: "notificationSettingsTab",
                },
                slot: "tab",
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.$t("message.soundSettings").length > 17
                        ? _vm.$t("message.soundSettings").substring(0, 17) +
                            "..."
                        : _vm.$t("message.soundSettings")
                    ) +
                    "\n            "
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "containerKeyThree" }, [
              _c(
                "div",
                { staticClass: "sound-settings-container" },
                _vm._l(
                  [
                    "newVisitor",
                    "newConversation",
                    "assignedChat",
                    "newMessage",
                    "teamChatTeam",
                    "teamChatDm",
                    "teamChatDepartment",
                    "teamChatGroup",
                    "newAnnouncement",
                    "newTicketSound",
                  ],
                  function (i, ii) {
                    return _c(
                      "div",
                      {
                        key: ii,
                        staticClass: "sound-settings-element width-500",
                      },
                      [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "tippy",
                                rawName: "v-tippy",
                                value: {
                                  placement: "top",
                                  zIndex: 1001,
                                },
                                expression:
                                  "{\n                                placement: 'top',\n                                zIndex: 1001,\n                            }",
                              },
                            ],
                            staticClass: "sound-settings-title",
                            attrs: { content: _vm.vtippyMessages[ii] },
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t("message." + i)) +
                                "\n                        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-select",
                          {
                            directives: [
                              {
                                name: "tippy",
                                rawName: "v-tippy",
                                value: {
                                  placement: "top",
                                  zIndex: 1001,
                                },
                                expression:
                                  "{\n                                placement: 'top',\n                                zIndex: 1001,\n                            }",
                              },
                            ],
                            staticClass: "sound-settings-select",
                            attrs: {
                              content: _vm.$t(
                                "message.vtippySelectnotification"
                              ),
                            },
                            on: {
                              change: function ($event) {
                                return _vm.playPreviewSound(
                                  _vm.notificationSettings[ii]
                                )
                              },
                            },
                            model: {
                              value: _vm.notificationSettings[ii].soundFile,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.notificationSettings[ii],
                                  "soundFile",
                                  $$v
                                )
                              },
                              expression: "notificationSettings[ii].soundFile",
                            },
                          },
                          _vm._l(_vm.soundFiles, function (s) {
                            return _c(
                              "b-form-select-option",
                              { key: s, attrs: { value: s } },
                              [
                                _vm._v(
                                  _vm._s(s) + "\n                            "
                                ),
                              ]
                            )
                          }),
                          1
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.notificationSettings[ii].audioLevel,
                              expression: "notificationSettings[ii].audioLevel",
                            },
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: {
                                placement: "top",
                                zIndex: 1001,
                              },
                              expression:
                                "{\n                                placement: 'top',\n                                zIndex: 1001,\n                            }",
                            },
                          ],
                          attrs: {
                            id: i,
                            max: "100",
                            min: "0",
                            name: i,
                            step: "10",
                            type: "range",
                            content: _vm.$t("message.vtippyVoiceLevel"),
                          },
                          domProps: {
                            value: _vm.notificationSettings[ii].audioLevel,
                          },
                          on: {
                            change: function ($event) {
                              return _vm.playPreviewSound(
                                _vm.notificationSettings[ii]
                              )
                            },
                            __r: function ($event) {
                              return _vm.$set(
                                _vm.notificationSettings[ii],
                                "audioLevel",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: i } }, [
                          _vm._v(
                            _vm._s(_vm.notificationSettings[ii].audioLevel) +
                              "%"
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "md-button",
                          {
                            directives: [
                              {
                                name: "tippy",
                                rawName: "v-tippy",
                                value: {
                                  placement: "top",
                                  zIndex: 1001,
                                },
                                expression:
                                  "{\n                                placement: 'top',\n                                zIndex: 1001,\n                            }",
                              },
                            ],
                            staticClass:
                              "md-icon-button md-primary play-sound-button",
                            attrs: {
                              content: _vm.$t("message.vtippyStartVoice"),
                            },
                            on: {
                              click: function ($event) {
                                return _vm.playPreviewSound(
                                  _vm.notificationSettings[ii]
                                )
                              },
                            },
                          },
                          [_c("md-icon", [_vm._v("play_circle")])],
                          1
                        ),
                        _vm._v(" "),
                        _vm.notificationSettings[ii].type === "new_chat"
                          ? _c(
                              "md-button",
                              {
                                directives: [
                                  {
                                    name: "tippy",
                                    rawName: "v-tippy",
                                    value: {
                                      placement: "top",
                                      zIndex: 1001,
                                    },
                                    expression:
                                      "{\n                                placement: 'top',\n                                zIndex: 1001,\n                            }",
                                  },
                                ],
                                staticClass:
                                  "md-icon-button md-primary play-sound-button",
                                attrs: {
                                  content: _vm.$t(
                                    "message.vtippyInfiniteNotification"
                                  ),
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.notificationSettings[ii].infinitePlay =
                                      !_vm.notificationSettings[ii].infinitePlay
                                  },
                                },
                              },
                              [
                                _c(
                                  "md-icon",
                                  {
                                    style: {
                                      color: !_vm.notificationSettings[ii]
                                        .infinitePlay
                                        ? "red"
                                        : "green",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "all_inclusive\n                            "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  }
                ),
                0
              ),
              _vm._v(" "),
              _c("div", { staticClass: "desktop-notifications" }, [
                _c("p", { staticClass: "desktop-notifications-title" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("message.desktopNotifications")) +
                      "\n                    "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "desktop-notifications-switches" },
                  _vm._l(
                    [
                      "newVisitor",
                      "newConversation",
                      "chatAssignedToUser",
                      "newMessage",
                      "newAnnouncement",
                      "newTicketSound",
                    ],
                    function (i, ii) {
                      return _c(
                        "div",
                        { key: ii },
                        [
                          _c("span", { staticClass: "listItem" }, [
                            _vm._v(_vm._s(_vm.$t("message." + i))),
                          ]),
                          _vm._v(" "),
                          _c("md-switch", {
                            staticClass: "md-primary",
                            model: {
                              value:
                                _vm.notificationSettings[ii]
                                  .desktopNotification,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.notificationSettings[ii],
                                  "desktopNotification",
                                  $$v
                                )
                              },
                              expression:
                                "notificationSettings[ii].desktopNotification",
                            },
                          }),
                        ],
                        1
                      )
                    }
                  ),
                  0
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "notification-warning" }, [
                _c("img", {
                  staticClass: "notification-warning-img",
                  attrs: {
                    alt: "warning",
                    src: "https://static.supsis.live/secure.png",
                  },
                }),
                _vm._v(" "),
                _c("p", { staticClass: "notification-warning-text" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("message.problemsSound")) +
                      "\n                    "
                  ),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("a-tab-pane", { key: "4" }, [
            _c(
              "span",
              {
                attrs: {
                  slot: "tab",
                  title: _vm.$t("message.languageSettings"),
                },
                slot: "tab",
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.$t("message.languageSettings").length > 17
                        ? _vm.$t("message.languageSettings").substring(0, 17) +
                            "..."
                        : _vm.$t("message.languageSettings")
                    ) +
                    "\n            "
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "containerKeyFour" }, [
              _c("label", { staticClass: "key-four-label" }, [
                _vm._v(_vm._s(_vm.$t("message.languageSettings")) + ":"),
              ]),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.lang,
                      expression: "lang",
                    },
                  ],
                  staticClass: "keyfour-select",
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.lang = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                  },
                },
                _vm._l(_vm.languages, function (lang) {
                  return _c("option", { domProps: { value: lang.code } }, [
                    _vm._v(_vm._s(lang.originalName)),
                  ])
                }),
                0
              ),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }